var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShippingFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1067,
    height: 1024,
    viewBox: "0 0 1067 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.333 307.104v45.511h386.846v341.332h-140.083c-10.15-39.117-45.33-68.267-87.474-68.267s-77.323 29.15-87.472 68.267h-26.305v-341.332h-45.511v386.845h71.817c10.149 39.117 45.329 68.267 87.472 68.267s77.324-29.15 87.474-68.267h189.141c10.15 39.117 45.329 68.267 87.475 68.267 42.142 0 77.321-29.15 87.471-68.267h71.817v-185.596l-1.434-3.571-45.513-136.534-4.937-15.633h-198.43v-91.023h-432.354zM629.687 443.639h165.683l39.117 116.621v133.687h-26.304c-10.15-39.117-45.329-68.267-87.471-68.267-42.146 0-77.325 29.15-87.475 68.267h-3.55v-250.308zM356.622 671.194c25.418 0 45.511 20.092 45.511 45.513 0 25.417-20.093 45.508-45.511 45.508s-45.511-20.092-45.511-45.508c0-25.421 20.093-45.513 45.511-45.513zM720.713 671.194c25.417 0 45.508 20.092 45.508 45.513 0 25.417-20.092 45.508-45.508 45.508-25.421 0-45.513-20.092-45.513-45.508 0-25.421 20.092-45.513 45.513-45.513z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingFast);
export default __webpack_public_path__ + "static/media/shipping-fast.95d97e017404cda95a0624c6acacbdc9.svg";
export { ForwardRef as ReactComponent };